import styled, { css, keyframes } from "styled-components";
export const Circle = styled.svg<{ break: boolean }>`
  position: absolute;
  transform: rotate(0.25turn);
  width: 856px;
  height: 856px;
  background-color: black;
  border-radius: 438px;
  box-shadow: ${({ break: isBreak }) =>
    !isBreak
      ? "0px 0px 50px 5px rgba(255, 255, 255, 0.5), 0px 0px 80px 5px #6436e7"
      : "none"};
  circle {
    fill: none;
    stroke-width: 25;
    stroke-linecap: round;
  }

  .background {
    stroke: rgba(240, 240, 240, 0.2);
  }

  .progress {
    stroke: ${({ break: isBreak }) => (!isBreak ? "#b2bce6" : "#DC0000")};
    transition: stroke-dashoffset 0.35s;
    transform: scaleX(-1);
    transform-origin: center;
  }
`;
export const Circle2 = styled(Circle)`
  width: 1012px;
  height: 1012px;
  border-radius: 506px;
  circle {
    fill: none;
    stroke-width: 30;
    stroke-linecap: round;
  }
`;
export const Timer2Background = styled.div<{ backgroundImage: string }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${({ backgroundImage }) =>
    `url(${backgroundImage}) lightgray 50% / cover no-repeat`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  filter: blur(2.5px);
  opacity: 0.4;
`;
export const CircularProgress = styled.div<{ progress: number }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 812px;
  height: 812px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: scaleX(-1);

  &::before {
    z-index: 999;
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 50%;
    background: conic-gradient(
      transparent ${(props) => 100 - props.progress}%,
      black ${(props) => 100 - props.progress}%
    );
  }
`;
export const CircularProgress2 = styled(CircularProgress)`
  width: 952px;
  height: 952px;
`;

export const Timer2BlindWrapper = styled.div`
  position: absolute;
  bottom: 30px;
  left: 192px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Timer2Blind = styled.div`
  display: flex;
  width: 766px;
  height: 119px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 35px;
  border: 1px solid #fff;
  background: rgba(0, 0, 0, 0.8);

  > .title {
    color: #fff;
    text-align: center;
    font-family: "Termina Test";
    font-size: 33px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  > .value {
    display: flex;
    flex-direction: row;
    gap: 10px;
    > .blind {
      color: #fff;
      text-align: center;
      font-family: "Termina Test";
      font-size: 50px;
      font-style: normal;
      font-weight: 900;
      line-height: 60.887px; /* 121.775% */
    }

    > .ante {
      color: #fff;
      font-family: "Termina Test";
      font-size: 42.621px;
      font-style: normal;
      font-weight: 900;
      line-height: 60.887px;
    }
  }
`;

export const Timer2NextBlind = styled(Timer2Blind)`
  > .title.next {
    color: #b3b3b3;
    text-align: center;
    font-family: "Termina Test";
    font-size: 25.32px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  > .value {
    > .blind.next {
      color: #b3b3b3;
      text-align: center;
      font-family: "Termina Test";
      font-size: 42.001px;
      font-style: normal;
      font-weight: 900;
      line-height: 46.668px; /* 111.111% */
    }

    > .ante.next {
      color: #b3b3b3;
      font-family: "Termina Test";
      font-size: 32.668px;
      font-style: normal;
      font-weight: 900;
      line-height: 46.668px;
    }
  }
`;

export const Timer2PrizeWrapper = styled.div`
  z-index: 2;
  padding: 30px;
  min-width: 0;
  max-width: 676px;
  height: 769px;
  border-radius: 35px;
  background: rgba(0, 0, 0, 0.5);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  position: relative;

  > img {
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
  }
`;

export const Timer2PrizeListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  > .title {
    color: #fff;
    font-family: "Termina Test";
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  > .list-wrapper {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
`;

const slideAnimation = keyframes`
  0% {
    transform: translateY(100%);
    opacity: 0;
  }
  15% {
    transform: translateY(0);
    opacity: 1;
  }
  85% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(-40%);
    opacity: 0;
  }
`;

export const Timer2PrizeItem = styled.div<{ isHigh: boolean; length: number }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 40px);
  border-radius: 15.04px;
  padding: 0 20px;
  height: ${({ isHigh }) => (isHigh ? "80px" : "60px")};
  background-color: ${({ isHigh }) => (isHigh ? "#363636" : "")};
  ${({ length }) =>
    length >= 10 &&
    css`
      animation: ${slideAnimation} 9s linear infinite;
    `}

  > .rank {
    color: #fff;
    font-family: Pretendard;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  > .prize-wrapper {
    display: flex;
    flex-direction: row;
    gap: 25px;
    align-items: center;

    > .prize {
      color: #fff;
      text-align: center;
      font-family: Pretendard;
      font-size: 25px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      font-variant-numeric: tabular-nums;

      > span {
        margin-right: 15px;
        font-size: 55px;
        letter-spacing: 1px;
      }
    }
    > .prize.high {
      color: #fff;
      text-align: center;
      font-family: Pretendard;
      font-size: 27px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      > span {
        margin-right: 15px;
        font-size: 55px;
        letter-spacing: 1px;
      }
    }

    > .sub-prize {
      padding: 7.5px 15px;
      border-radius: 10px;

      color: #fff;
      text-align: center;
      font-family: Pretendard;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }

    > .sub-prize.high {
      background: #180e2c;
    }
  }

  > .rank.high {
    font-family: Pretendard;
    font-size: 45px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    background: linear-gradient(
      95deg,
      #d9ff00 0.13%,
      #fff 18.47%,
      #4bf95f 43.3%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

export const Timer2PrizeItemTop3 = styled.div<{ isHigh: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 40px);
  border-radius: 15.04px;
  padding: 0 20px;
  height: ${({ isHigh }) => (isHigh ? "80px" : "60px")};
  background-color: ${({ isHigh }) => (isHigh ? "#363636" : "")};

  > .rank {
    color: #fff;
    font-family: Pretendard;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  > .prize-wrapper {
    display: flex;
    flex-direction: row;
    gap: 25px;
    align-items: center;

    > .prize {
      color: #fff;
      text-align: center;
      font-family: Pretendard;
      font-size: 25px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      font-variant-numeric: tabular-nums;

      > span {
        margin-right: 15px;
        font-size: 55px;
        letter-spacing: 1px;
      }
    }
    > .prize.high {
      color: #fff;
      text-align: center;
      font-family: Pretendard;
      font-size: 27px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;

      > span {
        margin-right: 15px;
        font-size: 55px;
        letter-spacing: 1px;
      }
    }

    > .sub-prize {
      padding: 7.5px 15px;
      border-radius: 10px;

      color: #fff;
      text-align: center;
      font-family: Pretendard;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }

    > .sub-prize.high {
      background: #180e2c;
    }
  }

  > .rank.high {
    font-family: Pretendard;
    font-size: 45px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    background: linear-gradient(
      95deg,
      #d9ff00 0.13%,
      #fff 18.47%,
      #4bf95f 43.3%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

export const Timer2NoticeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  > .title {
    color: #fff;
    font-family: "Termina Test";
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  > .value-wrapper {
    border-radius: 15.04px;
    background: #363636;
    max-width: 636px;
    width: 100%;
    height: 663px;
    padding: 20px;
    color: #fff;
    font-family: "Termina Test";

    > .value {
      width: 100%;
      height: 100%;
      font-size: 30px;
      font-style: normal;
      font-weight: 700;
      line-height: 1.3;
      overflow: hidden;
      text-overflow: ellipsis; /* 초과된 부분에 "..." 표시 */
      overflow-wrap: break-word;
      display: -webkit-box; /* 웹킷 박스 모델로 설정 */
      -webkit-line-clamp: 17;
      -webkit-box-orient: vertical; /* 블록 방향 설정 */
    }
  }
`;

export const UserTimeWrapper2 = styled.div`
  padding: 20px 30px;
  padding-left: 67px;
  background: rgba(10, 9, 46, 0.8);
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 20px;
  max-width: 1920px;
  width: 100%;
  max-height: 1080px;
  height: 100%;
  box-sizing: border-box;

  > .background {
    background: #000000c4;
    width: 100%;
    height: 100%;
    position: absolute;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    top: 0;
    left: 0;
`;

export const Timer2InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  min-width: 456px;
`;

export const Timer2TimeContainer = styled.div`
  margin-top: 14px;
  width: 1012px;
  height: 1012px;
  flex-shrink: 0;
  border-radius: 1012px;
  background: #000;
  display: flex;
  flex-direction: column;

  align-items: center;
  > .timer-box {
    margin-top: 104px;
    z-index: 1;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    > .title-box {
      display: flex;
      flex-direction: column;
      text-align: center;
      gap: 10px;

      > .pub-name {
        color: #fff;
        font-family: Pretendard;
        font-size: 30px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin-bottom: 22px;
      }

      > .header {
        display: flex;
        flex-direction: row;
        gap: 19px;
        align-items: center;
        > img {
          width: 100px;
          height: 100px;
          object-fit: cover;
          border-radius: 100%;
        }
        > .info-row {
          display: flex;
          flex-direction: column;
          text-align: start;
          > .title {
            color: #fff;
            font-family: Pretendard;
            font-size: 40px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
          }
          > .type {
            color: #fff;
            font-family: Pretendard;
            font-size: 30px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
          }
        }
      }

      > .title {
        color: #fff;
        font-family: Pretendard;
        font-size: 50px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }
    }
    > .level-break {
      display: flex;
      flex-direction: row;
      margin-top: 20px;
      margin-bottom: 12px;
      gap: 10px;
      > .next-break {
        width: 433px;
        height: 94px;
        flex-shrink: 0;
        display: flex;
        gap: 10px;
        justify-content: center;
        align-items: center;
        border-radius: 47px;
        background: #706f6f;
        color: #fff;
        text-align: center;
        font-family: Pretendard;
        font-size: 25px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;

        > span {
          color: #fff;
          font-family: Pretendard;
          font-size: 45px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
        }
      }
      > .now-level {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 296px;
        height: 94px;
        border-radius: 62.312px;
        background: rgba(255, 255, 255, 0.3);
        color: #fff;
        text-align: center;
        font-family: Pretendard;
        font-size: 45px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }
      > .now-level.break {
        color: #fff;
        background: #f00;
      }
    }

    > .time {
      text-align: center;
      color: #fff;
      text-align: center;
      font-family: Pretendard;
      font-size: 260px;
      font-style: normal;
      font-weight: 900;
      line-height: 100%; /* 240px */
      letter-spacing: -9.6px;
      text-shadow:
        0px 0px 50px rgba(255, 255, 255, 0.5),
        0px 0px 80px #f00;
      font-variant-numeric: tabular-nums;
    }

    > .time.level {
      color: #fff;
      text-shadow:
        0px 0px 30px rgba(255, 255, 255, 0.5),
        0px 0px 80px #6436e7;
    }

    > .bottom {
      margin-left: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 20px;
      > .line {
        width: 2px;
        height: 61px;
        background: #fff;
      }
      > .item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        > .title {
          color: #a5a5a5;
          text-align: center;
          font-family: Pretendard;
          font-size: 26.145px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
        }

        > .value {
          color: #fff;
          text-align: center;
          font-family: Pretendard;
          font-size: 43.575px;
          font-style: normal;
          font-weight: 900;
          line-height: normal;
        }
        > .value.break {
          color: #676767;
        }

        > .value2 {
          width: 240px;
          color: #fff;
          text-align: center;
          font-family: Pretendard;
          font-size: 50px;
          font-style: normal;
          font-weight: 900;
          line-height: normal;
        }
        > .value2.break {
          color: #676767;
        }
      }
    }
  }
  .dash-wrapper {
    position: absolute;
    top: 64px;
    left: 97px;
    width: 952px;
    height: 952px;
    > img {
      width: 952px;
      height: 952px;
    }
  }
`;
